// shipping date


// Function to format the date as "Sat, Jan 18"
function formatDateAbbreviation(date) {
    const options = { weekday: 'short', month: 'short', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
}

// Get the current date and container element
let ws_example_currentDate = new Date();
let ws_example_container = document.getElementById('ws_example__ship_date');

// Add the advance date to the current date
ws_example_currentDate.setDate(ws_example_currentDate.getDate() + 1);

// Format the date as "Sat, Jan 18"
let ws_example_formattedDate = formatDateAbbreviation(ws_example_currentDate);

// Set the formatted date to the container
ws_example_container.innerText = ws_example_formattedDate;



// shipping date


// Product count

// Generate a random number between 4 and 9
const randomNumber = Math.floor(Math.random() * (9 - 4 + 1)) + 4; // 4 to 9

// Display the random number in elements with the class "eyeCount"
document.addEventListener("DOMContentLoaded", function() {
  const eyeCountElements = document.querySelectorAll(".eyeCount");

  if (eyeCountElements.length > 0) {
    eyeCountElements.forEach(element => {
      element.textContent = randomNumber;
    });
  }
});


// Product count